import { render } from "./Consult.vue?vue&type=template&id=730ca2cf&scoped=true"
import script from "./Consult.vue?vue&type=script&lang=ts"
export * from "./Consult.vue?vue&type=script&lang=ts"

import "./Consult.vue?vue&type=style&index=0&id=730ca2cf&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-730ca2cf"

export default script